import type { StyleProps } from "@ui/types";

export const styles = {
    modalContent: {
        h: "fit-content",
        minH: "full",
    },
} satisfies Record<string, StyleProps | ((...args: unknown[]) => StyleProps)>;
